"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableTopBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
var react_2 = require("@nextui-org/react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var paginationContext_1 = require("../../../../../../../contexts/paginationContext");
var main_1 = require("../../../../../../../reducers/slices/main");
var date_range_picker_1 = require("../../../components/date_range_picker");
var react_3 = require("react");
var order_list_report_1 = require("../../../../../../../api/calls/order/get/order_list_report");
var constants_1 = require("../../../constants");
var constants_2 = require("../../../../../../../constants/constants");
var TableTopBar = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var totalPages = (0, paginationContext_1.usePaginationContext)().totalPages;
    var pageTitle = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).pageTitle;
    var _a = (0, react_3.useState)(undefined), selectedBranchId = _a[0], setSelectedBranchId = _a[1];
    var _b = (0, react_3.useState)(undefined), selectedStatus = _b[0], setSelectedStatus = _b[1];
    var _onExportCSV = (0, react_3.useCallback)(function (_a) {
        var fromDate = _a.fromDate, toDate = _a.toDate;
        return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, order_list_report_1.order_list_report)(__assign(__assign({ from_date: fromDate, to_date: toDate }, (selectedStatus && { status: selectedStatus })), (selectedBranchId && { branch_id: selectedBranchId })))];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, handleResponse(response)];
                }
            });
        });
    }, [selectedStatus, selectedBranchId]);
    var _handleExportCSV = (0, react_3.useCallback)(function () {
        return dispatch((0, main_1.setContentModal)({
            title: "Pick Date Range",
            content: (0, jsx_runtime_1.jsx)(date_range_picker_1.DateRangePicker, { onExportCSV: _onExportCSV, csvHeaders: constants_1.orderCSVheaders, filename: "orders" }),
        }));
    }, []);
    var handleResponse = (0, react_3.useCallback)(function (response) {
        if (response.success) {
            return response.content;
        }
        else {
            dispatch((0, main_1.setContentModal)({ title: constants_2.REQUEST_ERROR_TITLE, content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: response.message }) }));
        }
    }, []);
    var actionButtons = [
        {
            label: "Export CSV",
            iconClassname: "solar:cloud-download-linear",
            onClick: function () {
                dispatch((0, main_1.setContentModal)({
                    title: "Pick Date Range",
                    content: (0, jsx_runtime_1.jsx)(date_range_picker_1.DateRangePicker, { onExportCSV: _onExportCSV, csvHeaders: constants_1.orderCSVheaders, filename: "orders" }),
                }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "mb-[18px] flex items-center justify-between" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex w-[400px] items-center gap-2" }, { children: [(0, jsx_runtime_1.jsx)("h1", __assign({ className: "text-2xl font-[700] leading-[32px]" }, { children: pageTitle })), (0, jsx_runtime_1.jsx)(react_2.Chip, __assign({ className: "hidden items-center text-default-500 sm:flex", size: "sm", variant: "flat" }, { children: totalPages }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-end gap-4" }, { children: actionButtons.map(function (button, index) { return ((0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "primary", onClick: button.onClick, endContent: (0, jsx_runtime_1.jsx)(react_1.Icon, { icon: button.iconClassname, width: 20 }) }, { children: button.label }), index)); }) }))] })));
};
exports.TableTopBar = TableTopBar;
